"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDisclaimerBtnTracking = exports.createDisclaimerTxt = exports.getLastHeadingBeforeElement = exports.getNextHeadingLevel = exports.createDisclaimerBtn = exports.changeDisclaimerBtnText = exports.toggleYoutubeLocalstorage = exports.isYoutubeEnabled = void 0;
var I18n_1 = require("./I18n");
function isYoutubeEnabled() {
    return localStorage.getItem('oebb-yt-videos') ? true : false;
}
exports.isYoutubeEnabled = isYoutubeEnabled;
function toggleYoutubeLocalstorage() {
    if (isYoutubeEnabled()) {
        localStorage.removeItem('oebb-yt-videos');
    }
    else {
        localStorage.setItem('oebb-yt-videos', "true");
    }
}
exports.toggleYoutubeLocalstorage = toggleYoutubeLocalstorage;
function changeDisclaimerBtnText(disclaimerButton, lang) {
    if (!disclaimerButton)
        return;
    this.i18n = new I18n_1.I18n(lang);
    if (isYoutubeEnabled()) {
        disclaimerButton.textContent = this.i18n.getProperty('video-deactivate', 'YouTube deaktivieren');
    }
    else {
        disclaimerButton.innerHTML = '<span class="ic-play-white"></span> ' +
            this.i18n.getProperty('video-activate', 'YouTube aktivieren');
    }
}
exports.changeDisclaimerBtnText = changeDisclaimerBtnText;
function createDisclaimerBtn() {
    var disclaimerBtn = document.createElement('button');
    disclaimerBtn.classList.add('js-disclaimer-btn');
    disclaimerBtn.classList.add('video__disclaimer-btn');
    disclaimerBtn.classList.add('action-btn');
    disclaimerBtn.classList.add('action-btn--right');
    return disclaimerBtn;
}
exports.createDisclaimerBtn = createDisclaimerBtn;
function getNextHeadingLevel(tag) {
    var levels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    if (!tag)
        return 'h1';
    var idx = levels.indexOf(tag.toLowerCase());
    if (idx === -1)
        return 'h1';
    if (idx >= levels.length - 1)
        return 'h6';
    return levels[idx + 1];
}
exports.getNextHeadingLevel = getNextHeadingLevel;
function getLastHeadingBeforeElement(element, containerSelector) {
    if (containerSelector === void 0) { containerSelector = 'main'; }
    var container = document.querySelector(containerSelector);
    if (!container)
        return 'h1';
    var allHeadings = Array.from(container.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    var headings = allHeadings.filter(function (h) { return !h.closest('.video__disclaimer, .js-video'); });
    var lastHeading = null;
    for (var _i = 0, headings_1 = headings; _i < headings_1.length; _i++) {
        var h = headings_1[_i];
        if (h.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) {
            lastHeading = h;
        }
        else {
            break;
        }
    }
    return lastHeading ? lastHeading.tagName.toLowerCase() : 'null';
}
exports.getLastHeadingBeforeElement = getLastHeadingBeforeElement;
function createDisclaimerTxt(lang, videoElement, containerSelector) {
    var i18n = new I18n_1.I18n(lang);
    var disclaimer = document.createElement('div');
    disclaimer.classList.add('video__disclaimer');
    var lastHeading = getLastHeadingBeforeElement(videoElement, containerSelector);
    var nextHeadingTag = lastHeading ? getNextHeadingLevel(lastHeading) : 'h1';
    var headline = document.createElement(nextHeadingTag);
    headline.textContent = i18n.getProperty('video-disclaimer-headline', '');
    var paragraph = document.createElement('p');
    paragraph.innerHTML = i18n.getProperty('video-disclaimer', '');
    disclaimer.appendChild(headline);
    disclaimer.appendChild(paragraph);
    return disclaimer;
}
exports.createDisclaimerTxt = createDisclaimerTxt;
function updateDisclaimerBtnTracking(video, button) {
    delete button.dataset.trackContent;
    delete button.dataset.contentName;
    delete button.dataset.contentPiece;
    if (!isYoutubeEnabled()) {
        if (video.dataset.contentNameActivate && video.dataset.contentPieceActivate) {
            button.dataset.trackContent = '';
            button.dataset.contentName = video.dataset.contentNameActivate;
            button.dataset.contentPiece = video.dataset.contentPieceActivate;
        }
    }
    else {
        if (video.dataset.contentNameDeactivate && video.dataset.contentPieceDeactivate) {
            button.dataset.trackContent = '';
            button.dataset.contentName = video.dataset.contentNameDeactivate;
            button.dataset.contentPiece = video.dataset.contentPieceDeactivate;
        }
    }
}
exports.updateDisclaimerBtnTracking = updateDisclaimerBtnTracking;
